import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../../api/axios';
const COLORS = {
  bg: "#200A08",
  surface: "#341210",
  surfaceAlt: "#411713",
  orange: "#FF7A33",
  gold: "#FFC93C",
  teal: "#2EC4B6",
  ink: "#FBEDE2",
  muted: "#C9A79B",
};

const FONT_DISPLAY = '"Arial Black", "Helvetica Neue", Arial, sans-serif';
const FONT_BODY = 'ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif';
const FONT_MONO = 'ui-monospace, "Cascadia Code", "SFMono-Regular", Menlo, monospace';

const BlogList = ({ terminalMode = false }) => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/posts")
      .then(res => {
        console.log("Posts recibidos:", res.data);
        const posts = res.data.data || [];
        const sortedPosts = posts.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        setBlogPosts(sortedPosts);
        setLoading(false);
      })
      .catch(err => {
        console.error("Error al obtener posts:", err);
        const mockPosts = [
          { 
            id: 1, 
            title: "Post de Error en Carga", 
            content: "Contenido de ejemplo...", 
            created_at: new Date() 
          }
        ];
        setBlogPosts(mockPosts);
        setLoading(false);
      });
  }, []);

  return (
    <div style={{ background: COLORS.bg, color: COLORS.ink, fontFamily: FONT_BODY }} className="min-h-screen w-full">
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <p
          style={{ fontFamily: FONT_MONO, color: COLORS.teal, letterSpacing: "0.15em" }}
          className="text-xs md:text-sm uppercase mb-6"
        >
          Blog
        </p>

        <div className="relative inline-block mb-12">
          <span style={{ background: COLORS.orange, transform: "skewY(-2deg)" }} className="absolute inset-0 -z-0" />
          <h1
            style={{ fontFamily: FONT_DISPLAY, color: COLORS.bg, letterSpacing: "-0.02em" }}
            className="relative z-10 text-4xl md:text-6xl uppercase px-3 py-1"
          >
            Artículos
          </h1>
        </div>

        <div style={{ background: COLORS.surface, borderRadius: 14 }} className="p-6 md:p-8">
          {loading ? (
            <div style={{ fontFamily: FONT_MONO, color: COLORS.muted }} className="text-center py-8">
              Cargando artículos...
            </div>
          ) : blogPosts.length === 0 ? (
            <div style={{ fontFamily: FONT_MONO, color: COLORS.muted }} className="text-center py-8">
              No hay artículos disponibles
            </div>
          ) : (
            <div className="space-y-4">
              {blogPosts.map(post => (
                <Link
                  key={post.id}
                  to={`/BlogPost/${post.id}`}
                  className="block p-4 hover:bg-gray-800 transition rounded"
                  style={{ 
                    background: COLORS.surfaceAlt,
                    borderRadius: 8,
                    border: `1px solid ${COLORS.surface}`
                  }}
                >
                  <div className="flex justify-between items-start">
                    <h2 
                      style={{ fontFamily: FONT_DISPLAY, color: COLORS.ink }}
                      className="text-xl md:text-2xl"
                    >
                      {post.title}
                    </h2>
                    <span 
                      style={{ fontFamily: FONT_MONO, color: COLORS.muted }}
                      className="text-xs whitespace-nowrap ml-4"
                    >
                      {post.created_at ? new Date(post.created_at).toLocaleDateString('es-ES', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                      }) : 'Fecha no disponible'}
                    </span>
                  </div>
                  {post.content && (
                    <p 
                      style={{ fontFamily: FONT_BODY, color: COLORS.muted }}
                      className="mt-2 text-sm line-clamp-2"
                    >
                      {post.content.substring(0, 150)}
                      {post.content.length > 150 && '...'}
                    </p>
                  )}
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlogList;